import {
  FeatureFlags,
  type QuickLoginMethods,
  type QuickLoginRow,
} from "@observe-tech/utils";
import { createBridgeClient } from "./electronBridge";

const featureFlags = new FeatureFlags();

const QUICK_LOGIN_METHOD_NAMES = [
  "isQuickLoginAvailable",
  "listQuickLogins",
  "rememberQuickLogin",
  "setQuickLoginPin",
  "unlockQuickLogin",
  "removeQuickLoginPin",
  "declineQuickLogin",
  "forgetQuickLogin",
] as const satisfies readonly (keyof QuickLoginMethods)[];

const quickLoginBridge = createBridgeClient<QuickLoginMethods>(
  "quickLoginSession",
  QUICK_LOGIN_METHOD_NAMES,
);

export function isQuickLoginCapable(): boolean {
  return (
    quickLoginBridge.hasAllMethods() &&
    featureFlags.isFeatureEnabled("FEATUREFLAG_QUICK_LOGIN")
  );
}

export function listQuickLogins(): Promise<QuickLoginRow[]> {
  return quickLoginBridge.call<QuickLoginRow[]>(
    "listQuickLogins",
    (bridge) => bridge.listQuickLogins?.(),
    [],
  );
}
